import { render, staticRenderFns } from "./batchUploadImage.vue?vue&type=template&id=ca21f2ae&"
import script from "./batchUploadImage.vue?vue&type=script&lang=js&"
export * from "./batchUploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca21f2ae')) {
      api.createRecord('ca21f2ae', component.options)
    } else {
      api.reload('ca21f2ae', component.options)
    }
    module.hot.accept("./batchUploadImage.vue?vue&type=template&id=ca21f2ae&", function () {
      api.rerender('ca21f2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/batchUploadImage.vue"
export default component.exports